import styled from 'styled-components';
  
export const Overlay = styled.div`
 background: rgba(0, 0, 0, 0.8);
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  img {
    width: auto;
    height: auto;
    max-width: 80%;
    max-height: 80%;
    z-index: 9999;
  }

  svg {
    cursor: pointer;
    position: fixed;
    top: 2rem;
    right: 2rem;
    width: 3.125rem;
    height: 3.125rem;
  }
`

export const CoordinatesWrapper = styled.div`
  position: fixed;
  left: 2rem;
  bottom: 2rem;
  font-weight: bold;
`

export const CoordinatesContainer = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  button {
    padding: 0.3rem;
    border-radius: 0.2rem;
  }
`